<div
  class="ui info icon message text-center"
  *ngIf="isBanner"
  style="border-radius: 0px"
  appMargin
  marginB="0px"
>
  <!-- <i class="big info circle icon"></i> -->
  <div class="content">
    <span class="link">{{ bannerDesc }}</span>
    <button
      class="ui primary button"
      style="margin-left: 15px"
      (click)="showBanner()"
    >
      VIEW MESSAGE
    </button>
  </div>
</div>
<div class="ui menu toolbar" paddingX="10" appPadding marginY="0px" appMargin>
  <div class="ui container">
    <div class="item header" style="margin-left: -22px; border: none">
      <img class="ui image logo" src="../../../assets/images/ncc-logo.svg" />
      <p class="header-text">E-services</p>

      <!-- <img class="ui image logo" src="./assets/images/logo.svg" popupText="A Data collection and analytics tool" /> -->
    </div>

    <div class="right menu" *ngIf="!isRestrictedEntity">
      <div
        class="user top right pointing ui dropdown item"
        style="margin-right: -16px"
        suiDropdown
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.07035 7.41406H0V12.617H6.07035V7.41406Z" fill="white" />
          <path
            d="M12.445 13.7881H7.2421V19.9998H12.445V13.7881Z"
            fill="white"
          />
          <path d="M20 7.41406H13.6168V12.617H20V7.41406Z" fill="white" />
          <path
            d="M12.445 7.41406H7.2421V12.617H12.445V7.41406Z"
            fill="white"
          />
          <path d="M12.445 0H7.2421V6.24223H12.445V0Z" fill="white" />
          <path
            d="M6.07039 13.7883H0V17.7778C0 19.0031 0.996836 20 2.22215 20H6.07043V13.7883H6.07039Z"
            fill="white"
          />
          <path
            d="M17.7779 0H13.6166V6.24215H20V2.22215C20 0.996836 19.0031 0 17.7779 0Z"
            fill="white"
          />
          <path
            d="M13.6166 13.7883V19.9999H17.7778C19.0031 19.9999 20 19.0031 20 17.7778V13.7883H13.6166Z"
            fill="white"
          />
          <path
            d="M2.22215 0C0.996836 0 0 0.996836 0 2.22215V6.24219H6.07039V6.24215V0H2.22215Z"
            fill="white"
          />
        </svg>

        <i class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu>
          <ng-template ngFor let-app [ngForOf]="apps">
            <a
              class="item"
              target="_blank"
              *ngIf="app.applicationHost !== currentHost"
              href="{{ baseUrl }}/identity/continue/?return_url={{
                app?.applicationHost
              }}"
            >
              {{ app?.applicationName }}
            </a>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottom">
  <div
    class="container ui grid stackable"
    style="margin-top: -20px; justify-content: space-between"
  >
    <div class="left floated ten wide" style="padding-bottom: 0">
      <div class="ui pointing secondary menu grid">
        <a
          class="item"
          routerLink="/contractor/dashboard"
          routerLinkActive="active"
          style="padding-left: 0"
          >Home</a
        >
        <ng-container *ngIf="!isRestrictedEntity">
          <a
            class="item"
            *isPermitted="{ id: 'INVOICES_AND_PAYMENTS', action: 'read' }"
            routerLink="/contractor/invoice"
            routerLinkActive="active"
            >Invoices & Payments</a
          >
        </ng-container>
        <ng-container *ngIf="!isRestrictedEntity">
          <a
            class="item"
            *isPermitted="{ id: 'PAY_NCC', action: 'read' }"
            routerLink="/contractor/payment"
            routerLinkActive="active"
            >Pay NCC</a
          >
        </ng-container>

        <a
          class="item"
          *isPermitted="{ id: 'COMPANY_DETAILS', action: 'read' }"
          routerLink="/contractor/company"
          routerLinkActive="active"
          >Company Details</a
        >

        <a
          class="item"
          *isPermitted="{ id: 'CHAT', action: 'read' }"
          routerLink="/contractor/chat-window"
          routerLinkActive="active"
          >Chat with NCC</a
        >
        <a
          class="item"
          *isPermitted="{ id: 'CHAT', action: 'read' }"
          routerLink="/contractor/ai-chat"
          routerLinkActive="active"
          >AI Chat</a
        >
        <ng-container *ngIf="!isRestrictedEntity && !isMda">
          <a
            class="item"
            *isPermitted="{ id: 'AOL', action: 'read' }"
            routerLink="/contractor/aol"
            routerLinkActive="active"
            >AOL</a
          ></ng-container
        >
        <ng-container *ngIf="!isRestrictedEntity && applicationConfig">
          <a
            class="item"
            routerLink="/contractor/wallet"
            *isPermitted="{ id: 'eWALLET', action: 'read' }"
            routerLinkActive="active"
          >
            eWallet
            <div class="pill"><p>NEW</p></div>
          </a></ng-container
        >
      </div>
    </div>

    <div class="bottom-right">
      <div
        class="ui pointing top right dropdown item"
        style="align-self: flex-end"
        suiDropdown
      >
        <div class="msg">
          <i class="bell large icon" style="color: #fff"></i>
          <div class="floating ui red label mini circular">
            {{ totalUnread }}
          </div>
        </div>
        <div class="menu" suiDropdownMenu>
          <div class="ui grid basic fill attached segment no-padding">
            <div
              id="complaints"
              class="ui divided selection list"
              style="max-width: 500px; width: 500px; text-align: center"
              *ngIf="unRead && unRead.length > 0"
            >
              <div
                fxLayout="row"
                appPadding
                paddingY="5px"
                paddingX="2px"
                fxLayoutAlign="space-between center"
                *ngFor="let notification of unRead"
                style="
                  margin-bottom: 0px;
                  margin-top: 0px;
                  border-bottom: 1px solid #e0dede !important;
                "
              >
                <div fxFlex="10%">
                  <span
                    class="ui circular tiny empty red label"
                    *ngIf="notification.read != true"
                  ></span>
                  <span>
                    <i
                      class="large envelope outline icon"
                      [ngClass]="{ open: notification.read == true }"
                    ></i>
                    <!-- <i class="large email outline icon" style="margin-left: 15px;margin-top: 10px"></i> -->
                  </span>
                </div>
                <div fxFlex="grow">
                  <div
                    class="ui message"
                    style="
                      float: left;
                      padding: 0.2em 0.5em !important;
                      background: none !important;
                      -webkit-box-shadow: none !important;
                      box-shadow: none !important;
                    "
                  >
                    <div
                      class="header"
                      style="font-size: 12px; text-align: left"
                    >
                      <a class="item" routerLink="/contractor/notifications">
                        {{ notification?.subject }}
                      </a>
                    </div>
                  </div>
                </div>
                <div fxFlex="20%">
                  {{ notification.dateCreated | amTimeAgo }}
                </div>
              </div>

              <div class="item" style="text-align: center">
                <a [routerLink]="['/contractor/notifications']"> See All </a>
              </div>
            </div>

            <div class="ui divided selection list" *ngIf="!optionPopulated">
              <div class="content" style="width: 450px; text-align: center">
                <h3 style="padding: 15%">
                  <i class="big bell icon"></i>
                  <br />
                  No new notifications
                </h3>
              </div>
              <div
                class="ui divider"
                style="margin: 0px"
                *ngIf="total > 0"
              ></div>
              <div style="text-align: center" *ngIf="total > 0">
                <a class="item" [routerLink]="['/contractor/notifications']">
                  See All
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="submenudrop"
        class="ui pointing top right dropdown item"
        suiDropdown
      >
        <img class="ui circular avatar image" [src]="photo" />
        <div class="company-info" *ngIf="innerWidth > 1200">
          <div class="company-name">
            {{
              truncateSentence(
                (user.organizationId.organizationLongName
                  ? user?.organizationId?.organizationLongName
                  : user?.organizationId?.organizationShortName)
              )
            }}
          </div>
          <div class="role-type">
            {{ user?.roleId?.roleName }}
          </div>
        </div>

        <!-- hello team -->
        <i style="color: #fff" class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu>
          <div style="width: 344px">
            <div fxLayout="row" style="padding: 24px 18px; align-items: center">
              <div fxFlex="30%">
                <div class="ui basic fill segment">
                  <img
                    class="ui circular image"
                    style="object-fit: cover"
                    [src]="photo"
                  />
                </div>
              </div>
              <div fxFlex="70%">
                <div class="ui basic fill segment" style="color: black">
                  <div class="user-info">
                    <div class="user-name">
                      <strong
                        >{{ user?.firstName }} {{ user?.lastName }}
                        {{ user?.middleName }}</strong
                      >
                    </div>
                    <div class="role-name">
                      {{ user?.roleId?.roleName }}
                    </div>
                    <div
                      class="user-email"
                      style="
                        padding-bottom: 10px;
                        white-space: pre-line;
                        line-break: auto;
                        word-wrap: break-word;
                      "
                    >
                      {{ user?.appUserEmail }}
                    </div>
                  </div>
                  <a
                    class="ui blue button"
                    [routerLink]="['/contractor/setting/detail']"
                    >My Profile</a
                  >
                </div>
              </div>
            </div>
            <div
              fxLayout="row"
              class=""
              style="
                border-top: 1px solid #dededf;
                background: #f0f1f8;
                padding: 14px 18px;
              "
            >
              <div
                fxFlex
                class="ui basic fill segment"
                style="background: #f0f1f8 !important"
              >
                <!-- <a class="ui mini fluid button"  [routerLink]="['/admin/account']">Change password</a>
                                    <button class="ui mini fluid button" (click)="logout()">Sign out</button> -->
                <div class="link" [routerLink]="['/contractor/setting']">
                  Settings
                </div>
                <div class="ui divider" appMargin marginY="3"></div>
                <div
                  class="link"
                  [routerLink]="['/contractor/setting/account-security']"
                >
                  Change Password
                </div>
                <div class="ui divider" appMargin marginY="3"></div>
                <div class="link" (click)="logout()">Sign Out</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <small class="ui circular label" [ngClass]="{
                green: verified === 'VERIFIED',
                orange: verified === 'UNVERIFIED'
              }">{{ verified }}</small> -->
    </div>
  </div>
</div>
<p
  class="warning-label"
  *ngIf="user.totpEnabled && FADetails && FADetails?.provider === 'EMAIL'"
>
  Two-factor authentication (2FA) is now active on your account. You can use
  email for One-Time Passwords (OTPs) up to
  <span style="font-weight: bold">
    {{ FADetails?.maxAttemptsUsage - FADetails?.emailAttempts }} more
    times.</span
  >
  Go to Settings > Account Security in your account. Find the Two-Factor
  Authentication section and click the “Configure 2FA” link to set up your 2FA
  app.
</p>
<p class="warning-label" *ngIf="usedRecoveryCode && user.totpEnabled">
  Your account's Two-Factor Authentication (2FA) is currently in recovery mode.
  To re-establish your 2FA protection, go to Settings > Account Security in your
  account. Find the Two-Factor Authentication section and click the
  "Re-Configure 2FA" link to set up your 2FA app again.
</p>

<!-- <span class="route-link" [routerLink]="['/contractor/setting/account-security']"
  >Click here</span
>
to complete the process. -->
<div
  class="scroll-wrapper"
  [style.background-color]="isBackground ? '#f0f1f8' : '#fff'"
  appPadding
  paddingL="21px"
>
  <div class="ui container">
    <div class="ui basic segment" appPadding paddingT="12" paddingX="0">
      <router-outlet></router-outlet>
    </div>

    <!-- <div class="ui divider"></div>

    <div
      fxLayout="row"
      fxLayoutAlign="space-between"
      fxLayout.lt-sm="column"
      fxLayoutGap="15px"
      appMargin
      marginB="10"
    >
      <div fxFlex.lt-sm="100%">
        <div class="item" style="padding-left: 15px">
          @ Nigerian Communications Commission {{ year }}. All Rights Reserved
        </div>
      </div>
      <div
        fxFlex.lt-sm="100%"
        style="display: flex; flex-direction: column; align-items: end"
      >
        <div>
          <a class="item" target="_blank" href="https://ncc.gov.ng/"
            >NCC Website</a
          >
          &nbsp;| &nbsp;
          <a class="item" [routerLink]="['/home-page/terms-and-conditions']"
            >Terms & Condition</a
          >
          &nbsp;
        </div>
        <div style="margin-top: 10px">
          <img
            src="../../../assets//images/remita-payment-logo-horizonal.png"
            alt="ncc-logo"
            class="remita"
          />
        </div>
      </div>
    </div> -->
  </div>
</div>
